import { Button, FormLabel, Grid } from "@material-ui/core";
import { Form, Formik } from "formik";
import React from "react";
import useAlerts from "../../Base/AlertProvider";
import FormikTextField from "../../Base/Components/FormikTextField";
import { updateAdoptionDetails } from "../../Base/Services/RegistrationService";

function getFormValuesFromAdoptionDetails(registration) {
  const formValues = {
    notes: registration?.notes ?? "",
    locatorNumber: registration?.locatorNumber ?? "",
    stateFileNumber: registration?.stateFileNumber ?? "",
  };
  return formValues;
}

export default function AdoptionDetails({ ...props }) {
  const { addSuccessAlert, addErrorAlert } = useAlerts();

  function handleSaveBirthDetails(formik) {
    updateAdoptionDetails(props.registration.registrationId, {
      locatorNumber: formik.values.locatorNumber,
      stateFileNumber: formik.values.stateFileNumber,
      notes: formik.values.notes,
    })
      .then(() => {
        addSuccessAlert("Changes Saved");
      })
      .catch(() => {
        addErrorAlert("Error saving changes - please try again");
      });
  }

  return (
    <div>
      <Formik initialValues={getFormValuesFromAdoptionDetails(props.registration)}>
        {(formik) => (
          <Form>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ flexGrow: 1 }}>
                <FormLabel htmlFor="notes"> Notes</FormLabel>
                <FormikTextField name="notes" variant="filled" multiline rows={4} rowsMax={10} fullWidth />
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <FormikTextField name="locatorNumber" label="Locator Number" />
                  </Grid>
                  <Grid item xs={6}>
                    <FormikTextField name="stateFileNumber" label="State File Number" />
                  </Grid>
                </Grid>
              </div>
              <div style={{ paddingLeft: 20, display: "flex", alignItems: "flex-end" }}>
                <Button
                  color="primary"
                  variant="contained"
                  size="small"
                  autoFocus
                  onClick={() => handleSaveBirthDetails(formik)}
                >
                  Save
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
